import { AssetCategoryData, AssetData } from '../../../data/model';
import { DownloadsSectionTranslation } from '../../../localization/SiteTranslation';
import { AnalyticsAttributes } from '../../analytics/AnalyticsAttributes';
import { DataAttributes } from '../../common';
import Accordion from '../Accordion/Accordion';
import ActionButton from '../ActionButton';
import IconButton from '../Button/IconButton';
import Icon from '../Icon/Icon';
import List from '../List/List';
import css from './AssetsDownloader.css';
import { AssetsDownloaderState } from './AssetsDownloaderState';
import DownloadAssetLink from './DownloadAssetLink/DownloadAssetLink';

interface AssetsDownloaderProps extends DataAttributes {
  state: AssetsDownloaderState;
  translation: DownloadsSectionTranslation;
}

const AssetsDownloader = ({ state, translation, ...props }: AssetsDownloaderProps) => {
  const renderAsset = (asset: AssetData, categoryName: string) => (
    <DownloadAssetLink
      name={asset.name}
      url={asset.url}
      {...AnalyticsAttributes.merge(props, {
        id: 'File download',
        label: asset.name,
        'file-category': categoryName,
      })}
    />
  );

  const renderCategory = (category: AssetCategoryData) => {
    const { getCategoryName } = state;

    const categoryName = category.categoryName === '' ? translation.other : getCategoryName(category);

    return (
      category.assets.any() && (
        <Accordion
          title={categoryName}
          titleExpandedClassName={css.accordionExpandedTitle}
          titleClassName={css.accordionTitle}
          {...AnalyticsAttributes.merge(props, {
            id: 'Downloads documents category',
            label: categoryName,
          })}
        >
          <List items={category.assets} itemRenderer={(asset) => renderAsset(asset, categoryName)} />
        </Accordion>
      )
    );
  };

  return (
    <div className={css.AssetsDownloader}>
      <List className={css.categories} items={state.categories} itemRenderer={renderCategory} />
      <div className={css.downloadAll}>
        <ActionButton
          className={css.button}
          command={state.downloadAllCommand}
          buttonElement={IconButton}
          externalButtonProps={{
            nameClassName: css.name,
            loaderClassName: css.loader,
            icon: <Icon name="download" className={css.icon} />,
            ...AnalyticsAttributes.merge(props, {
              id: 'Download all',
              label: translation.downloadAllButton,
            }),
          }}
        >
          {translation.downloadAllButton}
        </ActionButton>
      </div>
    </div>
  );
};

export default AssetsDownloader;
